const measurementParameterTranslations = {
  en: {
    translation: {
      'measurementparameters.category.voltage': 'Spannungen',
      'measurementparameters.category.current': 'Ströme',
      'measurementparameters.category.frequency': 'Netzfrequenz',
      'measurementparameters.category.currents': 'Leiterströme',
      'measurementparameters.category.harmonics': 'Harmonische',
      'measurementparameters.category.harmonicsangles': 'Winkel der Harmonischen',
      'measurementparameters.category.interharmonics': 'Zwischenharmonische',
      'measurementparameters.category.thd': 'THD',
      'measurementparameters.category.unbalance': 'Unsymmetrie',
      'measurementparameters.category.voltagerms': 'Effektivwerte',
      'measurementparameters.category.voltageextremes': 'Spannungs-Extremwerte',
      'measurementparameters.category.pst': 'Kurzzeitflicker',
      'measurementparameters.category.plt': 'Langzeitflicker',
      'measurementparameters.category.voltageparameters': 'Spannungs-Messgrößen',
      'measurementparameters.category.phasephase': 'Leiter-Leiter',
      'measurementparameters.category.phaseground': 'Leiter-Erde',
      'measurementparameters.category.odd': 'Ungerade',
      'measurementparameters.category.even': 'Gerade',
      'measurementparameters.category.order01': '1. Ordnung',
      'measurementparameters.category.order10': '10. Ordnung',
      'measurementparameters.category.order11': '11. Ordnung',
      'measurementparameters.category.order12': '12. Ordnung',
      'measurementparameters.category.order13': '13. Ordnung',
      'measurementparameters.category.order14': '14. Ordnung',
      'measurementparameters.category.order15': '15. Ordnung',
      'measurementparameters.category.order16': '16. Ordnung',
      'measurementparameters.category.order17': '17. Ordnung',
      'measurementparameters.category.order18': '18. Ordnung',
      'measurementparameters.category.order19': '19. Ordnung',
      'measurementparameters.category.order02': '2. Ordnung',
      'measurementparameters.category.order20': '20. Ordnung',
      'measurementparameters.category.order21': '21. Ordnung',
      'measurementparameters.category.order22': '22. Ordnung',
      'measurementparameters.category.order23': '23. Ordnung',
      'measurementparameters.category.order24': '24. Ordnung',
      'measurementparameters.category.order25': '25. Ordnung',
      'measurementparameters.category.order26': '26. Ordnung',
      'measurementparameters.category.order27': '27. Ordnung',
      'measurementparameters.category.order28': '28. Ordnung',
      'measurementparameters.category.order29': '29. Ordnung',
      'measurementparameters.category.order03': '3. Ordnung',
      'measurementparameters.category.order30': '30. Ordnung',
      'measurementparameters.category.order31': '31. Ordnung',
      'measurementparameters.category.order32': '32. Ordnung',
      'measurementparameters.category.order33': '33. Ordnung',
      'measurementparameters.category.order34': '34. Ordnung',
      'measurementparameters.category.order35': '35. Ordnung',
      'measurementparameters.category.order36': '36. Ordnung',
      'measurementparameters.category.order37': '37. Ordnung',
      'measurementparameters.category.order38': '38. Ordnung',
      'measurementparameters.category.order39': '39. Ordnung',
      'measurementparameters.category.order04': '4. Ordnung',
      'measurementparameters.category.order40': '40. Ordnung',
      'measurementparameters.category.order41': '41. Ordnung',
      'measurementparameters.category.order42': '42. Ordnung',
      'measurementparameters.category.order43': '43. Ordnung',
      'measurementparameters.category.order44': '44. Ordnung',
      'measurementparameters.category.order45': '45. Ordnung',
      'measurementparameters.category.order46': '46. Ordnung',
      'measurementparameters.category.order47': '47. Ordnung',
      'measurementparameters.category.order48': '48. Ordnung',
      'measurementparameters.category.order49': '49. Ordnung',
      'measurementparameters.category.order05': '5. Ordnung',
      'measurementparameters.category.order50': '50. Ordnung',
      'measurementparameters.category.order06': '6. Ordnung',
      'measurementparameters.category.order07': '7. Ordnung',
      'measurementparameters.category.order08': '8. Ordnung',
      'measurementparameters.category.order09': '9. Ordnung',
      'measurementparameters.name.f': 'Netzfrequenz',
      'measurementparameters.name.i1': 'Effektivwert Strom',
      'measurementparameters.name.i1h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i1h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i1h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i1h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i1h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i1h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i1h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i1h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i1h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i1h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i1h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i1h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i1h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i1h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i1h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i1h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i1h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i1h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i1h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i1h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i1h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i1h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i1h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i1h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i1h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i1h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i1h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i1h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i1h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i1h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i1h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i1h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i1h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i1h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i1h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i1h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i1h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i1h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i1h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i1h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i1h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i1h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i1h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i1h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i1h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i1h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i1h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i1h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i1h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i1h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i1hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i1hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i1hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i1hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i1hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i1hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i1hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i1hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i1hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i1hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i1hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i1hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i1hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i1hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i1hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i1hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i1hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i1hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i1hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i1hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i1hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i1hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i1hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i1hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i1hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i1hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i1hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i1hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i1hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i1hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i1hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i1hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i1hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i1hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i1hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i1hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i1hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i1hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i1hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i1hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i1hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i1hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i1hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i1hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i1hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i1hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i1hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i1hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i1hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i1ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i1ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i1ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i1ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i1ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i1ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i1ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i1ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i1ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i1ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i1ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i1ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i1ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i1ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i1ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i1ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i1ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i1ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i1ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i1ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i1ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i1ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i1ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i1ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i1ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i1ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i1ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i1ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i1ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i1ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i1ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i1ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i1ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i1ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i1ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i1ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i1ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i1ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i1ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i1ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i1ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i1ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i1ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i1ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i1ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i1ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i1ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i1ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i1ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i1_thd': 'THD',
      'measurementparameters.name.i2': 'Effektivwert Strom',
      'measurementparameters.name.i2h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i2h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i2h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i2h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i2h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i2h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i2h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i2h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i2h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i2h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i2h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i2h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i2h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i2h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i2h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i2h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i2h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i2h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i2h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i2h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i2h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i2h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i2h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i2h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i2h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i2h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i2h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i2h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i2h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i2h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i2h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i2h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i2h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i2h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i2h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i2h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i2h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i2h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i2h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i2h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i2h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i2h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i2h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i2h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i2h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i2h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i2h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i2h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i2h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i2h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i2hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i2hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i2hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i2hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i2hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i2hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i2hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i2hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i2hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i2hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i2hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i2hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i2hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i2hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i2hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i2hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i2hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i2hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i2hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i2hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i2hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i2hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i2hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i2hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i2hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i2hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i2hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i2hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i2hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i2hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i2hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i2hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i2hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i2hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i2hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i2hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i2hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i2hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i2hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i2hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i2hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i2hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i2hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i2hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i2hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i2hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i2hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i2hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i2hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i2ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i2ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i2ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i2ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i2ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i2ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i2ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i2ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i2ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i2ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i2ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i2ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i2ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i2ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i2ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i2ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i2ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i2ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i2ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i2ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i2ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i2ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i2ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i2ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i2ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i2ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i2ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i2ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i2ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i2ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i2ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i2ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i2ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i2ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i2ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i2ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i2ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i2ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i2ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i2ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i2ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i2ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i2ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i2ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i2ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i2ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i2ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i2ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i2ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i2_thd': 'THD',
      'measurementparameters.name.i3': 'Effektivwert Strom',
      'measurementparameters.name.i3h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i3h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i3h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i3h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i3h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i3h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i3h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i3h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i3h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i3h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i3h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i3h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i3h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i3h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i3h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i3h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i3h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i3h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i3h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i3h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i3h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i3h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i3h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i3h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i3h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i3h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i3h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i3h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i3h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i3h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i3h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i3h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i3h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i3h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i3h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i3h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i3h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i3h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i3h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i3h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i3h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i3h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i3h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i3h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i3h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i3h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i3h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i3h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i3h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i3h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i3hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i3hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i3hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i3hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i3hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i3hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i3hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i3hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i3hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i3hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i3hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i3hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i3hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i3hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i3hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i3hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i3hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i3hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i3hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i3hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i3hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i3hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i3hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i3hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i3hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i3hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i3hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i3hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i3hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i3hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i3hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i3hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i3hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i3hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i3hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i3hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i3hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i3hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i3hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i3hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i3hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i3hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i3hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i3hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i3hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i3hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i3hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i3hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i3hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i3ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i3ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i3ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i3ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i3ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i3ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i3ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i3ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i3ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i3ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i3ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i3ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i3ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i3ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i3ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i3ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i3ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i3ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i3ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i3ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i3ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i3ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i3ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i3ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i3ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i3ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i3ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i3ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i3ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i3ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i3ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i3ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i3ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i3ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i3ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i3ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i3ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i3ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i3ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i3ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i3ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i3ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i3ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i3ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i3ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i3ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i3ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i3ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i3ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i3_thd': 'THD',
      'measurementparameters.name.i_u2': 'Unsymmetrie Gegen-/Mitsystem',
      'measurementparameters.name.u1': 'Effektivwert',
      'measurementparameters.name.u12': 'Effektivwert',
      'measurementparameters.name.u12h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u12h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u12h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u12h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u12h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u12h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u12h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u12h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u12h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u12h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u12h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u12h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u12h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u12h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u12h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u12h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u12h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u12h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u12h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u12h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u12h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u12h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u12h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u12h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u12h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u12h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u12h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u12h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u12h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u12h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u12h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u12h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u12h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u12h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u12h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u12h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u12h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u12h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u12h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u12h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u12h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u12h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u12h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u12h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u12h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u12h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u12h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u12h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u12h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u12h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u12ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u12ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u12ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u12ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u12ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u12ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u12ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u12ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u12ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u12ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u12ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u12ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u12ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u12ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u12ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u12ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u12ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u12ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u12ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u12ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u12ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u12ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u12ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u12ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u12ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u12ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u12ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u12ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u12ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u12ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u12ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u12ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u12ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u12ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u12ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u12ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u12ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u12ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u12ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u12ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u12ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u12ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u12ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u12ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u12ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u12ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u12ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u12ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u12ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u12_thd': 'THD',
      'measurementparameters.name.u1h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u1h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u1h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u1h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u1h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u1h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u1h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u1h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u1h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u1h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u1h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u1h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u1h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u1h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u1h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u1h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u1h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u1h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u1h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u1h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u1h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u1h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u1h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u1h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u1h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u1h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u1h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u1h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u1h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u1h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u1h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u1h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u1h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u1h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u1h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u1h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u1h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u1h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u1h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u1h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u1h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u1h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u1h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u1h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u1h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u1h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u1h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u1h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u1h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u1h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u1hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u1hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u1hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u1hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u1hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u1hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u1hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u1hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u1hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u1hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u1hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u1hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u1hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u1hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u1hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u1hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u1hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u1hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u1hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u1hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u1hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u1hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u1hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u1hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u1hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u1hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u1hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u1hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u1hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u1hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u1hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u1hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u1hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u1hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u1hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u1hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u1hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u1hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u1hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u1hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u1hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u1hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u1hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u1hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u1hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u1hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u1hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u1hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u1hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u1ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u1ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u1ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u1ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u1ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u1ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u1ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u1ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u1ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u1ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u1ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u1ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u1ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u1ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u1ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u1ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u1ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u1ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u1ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u1ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u1ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u1ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u1ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u1ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u1ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u1ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u1ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u1ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u1ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u1ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u1ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u1ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u1ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u1ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u1ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u1ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u1ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u1ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u1ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u1ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u1ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u1ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u1ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u1ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u1ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u1ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u1ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u1ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u1ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u1_thd': 'THD',
      'measurementparameters.name.u2': 'Effektivwert',
      'measurementparameters.name.u23': 'Effektivwert',
      'measurementparameters.name.u23h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u23h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u23h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u23h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u23h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u23h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u23h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u23h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u23h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u23h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u23h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u23h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u23h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u23h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u23h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u23h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u23h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u23h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u23h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u23h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u23h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u23h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u23h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u23h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u23h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u23h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u23h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u23h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u23h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u23h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u23h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u23h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u23h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u23h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u23h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u23h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u23h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u23h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u23h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u23h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u23h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u23h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u23h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u23h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u23h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u23h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u23h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u23h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u23h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u23h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u23ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u23ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u23ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u23ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u23ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u23ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u23ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u23ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u23ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u23ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u23ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u23ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u23ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u23ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u23ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u23ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u23ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u23ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u23ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u23ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u23ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u23ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u23ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u23ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u23ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u23ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u23ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u23ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u23ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u23ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u23ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u23ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u23ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u23ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u23ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u23ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u23ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u23ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u23ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u23ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u23ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u23ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u23ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u23ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u23ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u23ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u23ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u23ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u23ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u23_thd': 'THD',
      'measurementparameters.name.u2h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u2h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u2h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u2h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u2h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u2h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u2h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u2h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u2h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u2h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u2h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u2h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u2h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u2h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u2h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u2h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u2h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u2h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u2h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u2h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u2h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u2h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u2h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u2h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u2h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u2h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u2h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u2h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u2h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u2h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u2h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u2h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u2h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u2h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u2h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u2h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u2h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u2h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u2h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u2h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u2h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u2h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u2h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u2h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u2h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u2h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u2h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u2h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u2h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u2h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u2hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u2hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u2hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u2hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u2hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u2hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u2hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u2hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u2hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u2hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u2hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u2hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u2hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u2hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u2hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u2hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u2hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u2hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u2hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u2hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u2hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u2hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u2hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u2hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u2hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u2hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u2hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u2hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u2hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u2hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u2hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u2hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u2hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u2hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u2hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u2hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u2hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u2hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u2hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u2hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u2hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u2hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u2hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u2hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u2hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u2hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u2hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u2hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u2hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u2ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u2ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u2ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u2ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u2ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u2ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u2ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u2ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u2ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u2ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u2ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u2ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u2ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u2ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u2ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u2ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u2ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u2ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u2ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u2ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u2ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u2ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u2ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u2ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u2ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u2ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u2ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u2ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u2ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u2ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u2ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u2ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u2ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u2ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u2ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u2ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u2ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u2ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u2ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u2ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u2ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u2ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u2ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u2ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u2ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u2ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u2ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u2ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u2ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u2_thd': 'THD',
      'measurementparameters.name.u3': 'Effektivwert',
      'measurementparameters.name.u31': 'Effektivwert',
      'measurementparameters.name.u31h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u31h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u31h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u31h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u31h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u31h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u31h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u31h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u31h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u31h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u31h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u31h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u31h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u31h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u31h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u31h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u31h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u31h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u31h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u31h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u31h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u31h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u31h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u31h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u31h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u31h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u31h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u31h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u31h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u31h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u31h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u31h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u31h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u31h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u31h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u31h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u31h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u31h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u31h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u31h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u31h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u31h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u31h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u31h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u31h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u31h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u31h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u31h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u31h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u31h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u31ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u31ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u31ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u31ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u31ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u31ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u31ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u31ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u31ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u31ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u31ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u31ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u31ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u31ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u31ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u31ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u31ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u31ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u31ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u31ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u31ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u31ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u31ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u31ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u31ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u31ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u31ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u31ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u31ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u31ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u31ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u31ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u31ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u31ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u31ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u31ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u31ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u31ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u31ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u31ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u31ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u31ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u31ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u31ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u31ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u31ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u31ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u31ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u31ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u31_thd': 'THD',
      'measurementparameters.name.u3h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u3h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u3h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u3h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u3h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u3h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u3h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u3h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u3h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u3h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u3h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u3h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u3h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u3h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u3h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u3h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u3h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u3h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u3h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u3h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u3h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u3h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u3h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u3h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u3h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u3h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u3h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u3h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u3h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u3h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u3h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u3h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u3h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u3h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u3h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u3h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u3h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u3h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u3h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u3h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u3h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u3h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u3h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u3h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u3h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u3h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u3h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u3h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u3h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u3h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u3hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u3hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u3hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u3hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u3hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u3hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u3hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u3hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u3hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u3hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u3hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u3hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u3hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u3hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u3hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u3hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u3hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u3hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u3hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u3hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u3hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u3hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u3hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u3hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u3hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u3hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u3hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u3hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u3hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u3hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u3hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u3hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u3hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u3hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u3hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u3hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u3hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u3hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u3hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u3hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u3hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u3hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u3hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u3hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u3hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u3hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u3hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u3hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u3hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u3ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u3ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u3ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u3ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u3ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u3ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u3ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u3ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u3ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u3ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u3ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u3ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u3ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u3ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u3ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u3ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u3ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u3ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u3ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u3ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u3ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u3ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u3ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u3ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u3ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u3ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u3ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u3ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u3ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u3ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u3ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u3ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u3ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u3ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u3ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u3ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u3ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u3ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u3ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u3ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u3ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u3ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u3ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u3ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u3ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u3ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u3ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u3ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u3ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u3_thd': 'THD',
      'measurementparameters.name.uextru12_max': 'Ueff max (10ms) U12',
      'measurementparameters.name.uextru12_min': 'Ueff min (10ms) U12',
      'measurementparameters.name.uextru1_max': 'Ueff max (10ms) U1E / U1N',
      'measurementparameters.name.uextru1_min': 'Ueff min (10ms) U1E / U1N',
      'measurementparameters.name.uextru23_max': 'Ueff max (10ms) U23',
      'measurementparameters.name.uextru23_min': 'Ueff min (10ms) U23',
      'measurementparameters.name.uextru2_max': 'Ueff max (10ms) U2E / U2N',
      'measurementparameters.name.uextru2_min': 'Ueff min (10ms) U2E / U2N',
      'measurementparameters.name.uextru31_max': 'Ueff max (10ms) U31',
      'measurementparameters.name.uextru31_min': 'Ueff min (10ms) U31',
      'measurementparameters.name.uextru3_max': 'Ueff max (10ms) U3E / U3N',
      'measurementparameters.name.uextru3_min': 'Ueff min (10ms) U3E / U3N',
      'measurementparameters.name.ustatu12_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu1_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu23_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu2_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu31_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu3_pst': 'Kurzzeitflicker',
      'measurementparameters.name.u_u2': 'Unsymmetrie u 2 (Gegen-/Mitsystem) [Prozent] mit Vorzeichen Drehsinn (ROT)',
      'measurementparameters.name.upltu12_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu1_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu23_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu2_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu31_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu3_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.u12m': 'Betrag von Phasor u12',
      'measurementparameters.name.u12p': 'Phase von Phasor u12',
      'measurementparameters.name.u1m': 'Betrag von Phasor u1E / u1N',
      'measurementparameters.name.u1p': 'Phase von Phasor u1E / u1N',
      'measurementparameters.name.u23m': 'Betrag von Phasor u23',
      'measurementparameters.name.u23p': 'Phase von Phasor u23',
      'measurementparameters.name.u2m': 'Betrag von Phasor u2E / u2N',
      'measurementparameters.name.u2p': 'Phase von Phasor u2E / u2N',
      'measurementparameters.name.u31m': 'Betrag von Phasor u31',
      'measurementparameters.name.u31p': 'Phase von Phasor u31',
      'measurementparameters.name.u3m': 'Betrag von Phasor u3E / u3N',
      'measurementparameters.name.u3p': 'Phase von Phasor u3E / u3N',
    },
  },
  de: {
    translation: {
      'measurementparameters.category.voltage': 'Spannungen',
      'measurementparameters.category.current': 'Ströme',
      'measurementparameters.category.frequency': 'Netzfrequenz',
      'measurementparameters.category.currents': 'Leiterströme',
      'measurementparameters.category.harmonics': 'Harmonische',
      'measurementparameters.category.harmonicsangles': 'Winkel der Harmonischen',
      'measurementparameters.category.interharmonics': 'Zwischenharmonische',
      'measurementparameters.category.thd': 'THD',
      'measurementparameters.category.unbalance': 'Unsymmetrie',
      'measurementparameters.category.voltagerms': 'Effektivwerte',
      'measurementparameters.category.voltageextremes': 'Spannungs-Extremwerte',
      'measurementparameters.category.pst': 'Kurzzeitflicker',
      'measurementparameters.category.plt': 'Langzeitflicker',
      'measurementparameters.category.voltageparameters': 'Spannungs-Messgrößen',
      'measurementparameters.category.phasephase': 'Leiter-Leiter',
      'measurementparameters.category.phaseground': 'Leiter-Erde',
      'measurementparameters.category.odd': 'Ungerade',
      'measurementparameters.category.even': 'Gerade',
      'measurementparameters.category.order01': '1. Ordnung',
      'measurementparameters.category.order10': '10. Ordnung',
      'measurementparameters.category.order11': '11. Ordnung',
      'measurementparameters.category.order12': '12. Ordnung',
      'measurementparameters.category.order13': '13. Ordnung',
      'measurementparameters.category.order14': '14. Ordnung',
      'measurementparameters.category.order15': '15. Ordnung',
      'measurementparameters.category.order16': '16. Ordnung',
      'measurementparameters.category.order17': '17. Ordnung',
      'measurementparameters.category.order18': '18. Ordnung',
      'measurementparameters.category.order19': '19. Ordnung',
      'measurementparameters.category.order02': '2. Ordnung',
      'measurementparameters.category.order20': '20. Ordnung',
      'measurementparameters.category.order21': '21. Ordnung',
      'measurementparameters.category.order22': '22. Ordnung',
      'measurementparameters.category.order23': '23. Ordnung',
      'measurementparameters.category.order24': '24. Ordnung',
      'measurementparameters.category.order25': '25. Ordnung',
      'measurementparameters.category.order26': '26. Ordnung',
      'measurementparameters.category.order27': '27. Ordnung',
      'measurementparameters.category.order28': '28. Ordnung',
      'measurementparameters.category.order29': '29. Ordnung',
      'measurementparameters.category.order03': '3. Ordnung',
      'measurementparameters.category.order30': '30. Ordnung',
      'measurementparameters.category.order31': '31. Ordnung',
      'measurementparameters.category.order32': '32. Ordnung',
      'measurementparameters.category.order33': '33. Ordnung',
      'measurementparameters.category.order34': '34. Ordnung',
      'measurementparameters.category.order35': '35. Ordnung',
      'measurementparameters.category.order36': '36. Ordnung',
      'measurementparameters.category.order37': '37. Ordnung',
      'measurementparameters.category.order38': '38. Ordnung',
      'measurementparameters.category.order39': '39. Ordnung',
      'measurementparameters.category.order04': '4. Ordnung',
      'measurementparameters.category.order40': '40. Ordnung',
      'measurementparameters.category.order41': '41. Ordnung',
      'measurementparameters.category.order42': '42. Ordnung',
      'measurementparameters.category.order43': '43. Ordnung',
      'measurementparameters.category.order44': '44. Ordnung',
      'measurementparameters.category.order45': '45. Ordnung',
      'measurementparameters.category.order46': '46. Ordnung',
      'measurementparameters.category.order47': '47. Ordnung',
      'measurementparameters.category.order48': '48. Ordnung',
      'measurementparameters.category.order49': '49. Ordnung',
      'measurementparameters.category.order05': '5. Ordnung',
      'measurementparameters.category.order50': '50. Ordnung',
      'measurementparameters.category.order06': '6. Ordnung',
      'measurementparameters.category.order07': '7. Ordnung',
      'measurementparameters.category.order08': '8. Ordnung',
      'measurementparameters.category.order09': '9. Ordnung',
      'measurementparameters.name.f': 'Netzfrequenz',
      'measurementparameters.name.i1': 'Effektivwert Strom',
      'measurementparameters.name.i1h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i1h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i1h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i1h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i1h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i1h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i1h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i1h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i1h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i1h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i1h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i1h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i1h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i1h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i1h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i1h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i1h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i1h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i1h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i1h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i1h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i1h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i1h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i1h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i1h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i1h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i1h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i1h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i1h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i1h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i1h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i1h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i1h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i1h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i1h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i1h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i1h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i1h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i1h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i1h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i1h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i1h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i1h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i1h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i1h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i1h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i1h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i1h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i1h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i1h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i1hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i1hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i1hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i1hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i1hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i1hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i1hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i1hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i1hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i1hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i1hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i1hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i1hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i1hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i1hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i1hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i1hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i1hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i1hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i1hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i1hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i1hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i1hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i1hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i1hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i1hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i1hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i1hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i1hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i1hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i1hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i1hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i1hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i1hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i1hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i1hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i1hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i1hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i1hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i1hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i1hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i1hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i1hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i1hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i1hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i1hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i1hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i1hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i1hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i1ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i1ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i1ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i1ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i1ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i1ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i1ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i1ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i1ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i1ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i1ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i1ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i1ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i1ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i1ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i1ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i1ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i1ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i1ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i1ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i1ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i1ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i1ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i1ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i1ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i1ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i1ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i1ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i1ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i1ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i1ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i1ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i1ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i1ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i1ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i1ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i1ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i1ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i1ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i1ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i1ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i1ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i1ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i1ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i1ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i1ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i1ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i1ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i1ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i1_thd': 'THD',
      'measurementparameters.name.i2': 'Effektivwert Strom',
      'measurementparameters.name.i2h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i2h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i2h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i2h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i2h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i2h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i2h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i2h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i2h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i2h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i2h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i2h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i2h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i2h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i2h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i2h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i2h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i2h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i2h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i2h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i2h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i2h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i2h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i2h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i2h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i2h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i2h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i2h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i2h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i2h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i2h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i2h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i2h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i2h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i2h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i2h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i2h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i2h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i2h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i2h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i2h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i2h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i2h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i2h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i2h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i2h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i2h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i2h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i2h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i2h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i2hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i2hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i2hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i2hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i2hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i2hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i2hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i2hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i2hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i2hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i2hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i2hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i2hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i2hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i2hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i2hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i2hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i2hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i2hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i2hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i2hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i2hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i2hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i2hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i2hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i2hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i2hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i2hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i2hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i2hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i2hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i2hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i2hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i2hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i2hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i2hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i2hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i2hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i2hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i2hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i2hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i2hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i2hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i2hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i2hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i2hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i2hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i2hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i2hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i2ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i2ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i2ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i2ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i2ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i2ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i2ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i2ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i2ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i2ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i2ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i2ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i2ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i2ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i2ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i2ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i2ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i2ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i2ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i2ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i2ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i2ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i2ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i2ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i2ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i2ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i2ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i2ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i2ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i2ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i2ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i2ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i2ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i2ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i2ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i2ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i2ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i2ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i2ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i2ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i2ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i2ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i2ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i2ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i2ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i2ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i2ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i2ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i2ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i2_thd': 'THD',
      'measurementparameters.name.i3': 'Effektivwert Strom',
      'measurementparameters.name.i3h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.i3h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.i3h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.i3h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.i3h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.i3h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.i3h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.i3h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.i3h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.i3h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.i3h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.i3h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.i3h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.i3h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.i3h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.i3h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.i3h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.i3h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.i3h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.i3h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.i3h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.i3h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.i3h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.i3h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.i3h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.i3h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.i3h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.i3h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.i3h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.i3h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.i3h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.i3h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.i3h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.i3h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.i3h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.i3h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.i3h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.i3h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.i3h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.i3h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.i3h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.i3h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.i3h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.i3h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.i3h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.i3h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.i3h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.i3h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.i3h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.i3h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.i3hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.i3hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.i3hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.i3hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.i3hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.i3hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.i3hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.i3hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.i3hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.i3hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.i3hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.i3hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.i3hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.i3hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.i3hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.i3hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.i3hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.i3hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.i3hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.i3hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.i3hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.i3hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.i3hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.i3hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.i3hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.i3hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.i3hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.i3hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.i3hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.i3hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.i3hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.i3hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.i3hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.i3hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.i3hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.i3hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.i3hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.i3hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.i3hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.i3hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.i3hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.i3hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.i3hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.i3hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.i3hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.i3hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.i3hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.i3hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.i3hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.i3ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.i3ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.i3ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.i3ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.i3ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.i3ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.i3ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.i3ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.i3ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.i3ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.i3ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.i3ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.i3ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.i3ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.i3ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.i3ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.i3ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.i3ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.i3ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.i3ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.i3ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.i3ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.i3ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.i3ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.i3ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.i3ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.i3ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.i3ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.i3ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.i3ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.i3ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.i3ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.i3ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.i3ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.i3ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.i3ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.i3ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.i3ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.i3ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.i3ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.i3ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.i3ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.i3ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.i3ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.i3ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.i3ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.i3ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.i3ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.i3ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.i3_thd': 'THD',
      'measurementparameters.name.i_u2': 'Unsymmetrie Gegen-/Mitsystem',
      'measurementparameters.name.u1': 'Effektivwert',
      'measurementparameters.name.u12': 'Effektivwert',
      'measurementparameters.name.u12h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u12h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u12h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u12h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u12h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u12h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u12h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u12h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u12h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u12h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u12h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u12h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u12h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u12h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u12h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u12h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u12h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u12h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u12h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u12h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u12h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u12h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u12h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u12h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u12h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u12h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u12h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u12h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u12h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u12h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u12h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u12h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u12h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u12h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u12h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u12h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u12h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u12h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u12h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u12h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u12h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u12h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u12h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u12h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u12h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u12h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u12h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u12h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u12h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u12h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u12ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u12ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u12ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u12ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u12ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u12ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u12ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u12ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u12ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u12ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u12ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u12ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u12ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u12ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u12ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u12ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u12ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u12ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u12ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u12ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u12ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u12ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u12ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u12ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u12ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u12ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u12ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u12ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u12ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u12ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u12ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u12ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u12ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u12ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u12ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u12ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u12ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u12ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u12ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u12ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u12ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u12ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u12ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u12ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u12ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u12ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u12ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u12ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u12ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u12_thd': 'THD',
      'measurementparameters.name.u1h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u1h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u1h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u1h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u1h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u1h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u1h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u1h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u1h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u1h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u1h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u1h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u1h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u1h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u1h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u1h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u1h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u1h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u1h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u1h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u1h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u1h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u1h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u1h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u1h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u1h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u1h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u1h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u1h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u1h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u1h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u1h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u1h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u1h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u1h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u1h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u1h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u1h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u1h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u1h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u1h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u1h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u1h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u1h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u1h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u1h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u1h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u1h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u1h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u1h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u1hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u1hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u1hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u1hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u1hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u1hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u1hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u1hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u1hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u1hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u1hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u1hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u1hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u1hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u1hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u1hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u1hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u1hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u1hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u1hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u1hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u1hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u1hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u1hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u1hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u1hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u1hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u1hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u1hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u1hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u1hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u1hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u1hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u1hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u1hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u1hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u1hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u1hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u1hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u1hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u1hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u1hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u1hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u1hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u1hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u1hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u1hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u1hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u1hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u1ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u1ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u1ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u1ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u1ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u1ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u1ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u1ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u1ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u1ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u1ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u1ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u1ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u1ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u1ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u1ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u1ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u1ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u1ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u1ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u1ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u1ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u1ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u1ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u1ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u1ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u1ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u1ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u1ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u1ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u1ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u1ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u1ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u1ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u1ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u1ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u1ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u1ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u1ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u1ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u1ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u1ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u1ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u1ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u1ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u1ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u1ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u1ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u1ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u1_thd': 'THD',
      'measurementparameters.name.u2': 'Effektivwert',
      'measurementparameters.name.u23': 'Effektivwert',
      'measurementparameters.name.u23h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u23h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u23h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u23h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u23h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u23h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u23h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u23h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u23h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u23h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u23h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u23h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u23h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u23h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u23h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u23h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u23h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u23h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u23h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u23h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u23h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u23h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u23h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u23h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u23h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u23h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u23h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u23h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u23h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u23h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u23h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u23h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u23h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u23h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u23h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u23h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u23h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u23h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u23h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u23h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u23h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u23h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u23h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u23h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u23h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u23h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u23h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u23h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u23h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u23h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u23ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u23ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u23ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u23ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u23ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u23ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u23ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u23ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u23ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u23ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u23ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u23ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u23ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u23ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u23ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u23ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u23ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u23ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u23ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u23ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u23ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u23ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u23ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u23ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u23ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u23ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u23ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u23ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u23ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u23ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u23ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u23ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u23ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u23ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u23ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u23ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u23ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u23ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u23ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u23ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u23ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u23ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u23ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u23ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u23ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u23ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u23ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u23ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u23ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u23_thd': 'THD',
      'measurementparameters.name.u2h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u2h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u2h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u2h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u2h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u2h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u2h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u2h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u2h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u2h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u2h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u2h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u2h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u2h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u2h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u2h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u2h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u2h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u2h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u2h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u2h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u2h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u2h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u2h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u2h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u2h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u2h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u2h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u2h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u2h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u2h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u2h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u2h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u2h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u2h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u2h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u2h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u2h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u2h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u2h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u2h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u2h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u2h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u2h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u2h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u2h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u2h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u2h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u2h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u2h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u2hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u2hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u2hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u2hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u2hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u2hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u2hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u2hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u2hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u2hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u2hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u2hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u2hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u2hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u2hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u2hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u2hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u2hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u2hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u2hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u2hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u2hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u2hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u2hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u2hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u2hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u2hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u2hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u2hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u2hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u2hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u2hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u2hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u2hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u2hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u2hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u2hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u2hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u2hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u2hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u2hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u2hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u2hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u2hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u2hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u2hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u2hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u2hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u2hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u2ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u2ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u2ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u2ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u2ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u2ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u2ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u2ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u2ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u2ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u2ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u2ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u2ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u2ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u2ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u2ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u2ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u2ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u2ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u2ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u2ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u2ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u2ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u2ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u2ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u2ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u2ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u2ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u2ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u2ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u2ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u2ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u2ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u2ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u2ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u2ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u2ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u2ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u2ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u2ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u2ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u2ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u2ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u2ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u2ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u2ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u2ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u2ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u2ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u2_thd': 'THD',
      'measurementparameters.name.u3': 'Effektivwert',
      'measurementparameters.name.u31': 'Effektivwert',
      'measurementparameters.name.u31h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u31h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u31h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u31h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u31h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u31h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u31h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u31h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u31h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u31h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u31h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u31h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u31h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u31h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u31h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u31h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u31h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u31h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u31h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u31h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u31h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u31h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u31h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u31h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u31h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u31h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u31h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u31h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u31h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u31h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u31h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u31h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u31h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u31h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u31h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u31h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u31h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u31h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u31h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u31h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u31h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u31h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u31h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u31h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u31h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u31h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u31h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u31h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u31h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u31h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u31ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u31ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u31ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u31ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u31ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u31ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u31ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u31ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u31ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u31ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u31ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u31ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u31ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u31ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u31ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u31ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u31ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u31ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u31ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u31ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u31ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u31ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u31ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u31ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u31ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u31ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u31ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u31ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u31ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u31ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u31ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u31ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u31ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u31ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u31ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u31ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u31ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u31ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u31ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u31ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u31ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u31ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u31ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u31ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u31ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u31ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u31ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u31ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u31ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u31_thd': 'THD',
      'measurementparameters.name.u3h1': 'Harmonische 1. Ordnung',
      'measurementparameters.name.u3h10': 'Harmonische 10. Ordnung',
      'measurementparameters.name.u3h11': 'Harmonische 11. Ordnung',
      'measurementparameters.name.u3h12': 'Harmonische 12. Ordnung',
      'measurementparameters.name.u3h13': 'Harmonische 13. Ordnung',
      'measurementparameters.name.u3h14': 'Harmonische 14. Ordnung',
      'measurementparameters.name.u3h15': 'Harmonische 15. Ordnung',
      'measurementparameters.name.u3h16': 'Harmonische 16. Ordnung',
      'measurementparameters.name.u3h17': 'Harmonische 17. Ordnung',
      'measurementparameters.name.u3h18': 'Harmonische 18. Ordnung',
      'measurementparameters.name.u3h19': 'Harmonische 19. Ordnung',
      'measurementparameters.name.u3h2': 'Harmonische 2. Ordnung',
      'measurementparameters.name.u3h20': 'Harmonische 20. Ordnung',
      'measurementparameters.name.u3h21': 'Harmonische 21. Ordnung',
      'measurementparameters.name.u3h22': 'Harmonische 22. Ordnung',
      'measurementparameters.name.u3h23': 'Harmonische 23. Ordnung',
      'measurementparameters.name.u3h24': 'Harmonische 24. Ordnung',
      'measurementparameters.name.u3h25': 'Harmonische 25. Ordnung',
      'measurementparameters.name.u3h26': 'Harmonische 26. Ordnung',
      'measurementparameters.name.u3h27': 'Harmonische 27. Ordnung',
      'measurementparameters.name.u3h28': 'Harmonische 28. Ordnung',
      'measurementparameters.name.u3h29': 'Harmonische 29. Ordnung',
      'measurementparameters.name.u3h3': 'Harmonische 3. Ordnung',
      'measurementparameters.name.u3h30': 'Harmonische 30. Ordnung',
      'measurementparameters.name.u3h31': 'Harmonische 31. Ordnung',
      'measurementparameters.name.u3h32': 'Harmonische 32. Ordnung',
      'measurementparameters.name.u3h33': 'Harmonische 33. Ordnung',
      'measurementparameters.name.u3h34': 'Harmonische 34. Ordnung',
      'measurementparameters.name.u3h35': 'Harmonische 35. Ordnung',
      'measurementparameters.name.u3h36': 'Harmonische 36. Ordnung',
      'measurementparameters.name.u3h37': 'Harmonische 37. Ordnung',
      'measurementparameters.name.u3h38': 'Harmonische 38. Ordnung',
      'measurementparameters.name.u3h39': 'Harmonische 39. Ordnung',
      'measurementparameters.name.u3h4': 'Harmonische 4. Ordnung',
      'measurementparameters.name.u3h40': 'Harmonische 40. Ordnung',
      'measurementparameters.name.u3h41': 'Harmonische 41. Ordnung',
      'measurementparameters.name.u3h42': 'Harmonische 42. Ordnung',
      'measurementparameters.name.u3h43': 'Harmonische 43. Ordnung',
      'measurementparameters.name.u3h44': 'Harmonische 44. Ordnung',
      'measurementparameters.name.u3h45': 'Harmonische 45. Ordnung',
      'measurementparameters.name.u3h46': 'Harmonische 46. Ordnung',
      'measurementparameters.name.u3h47': 'Harmonische 47. Ordnung',
      'measurementparameters.name.u3h48': 'Harmonische 48. Ordnung',
      'measurementparameters.name.u3h49': 'Harmonische 49. Ordnung',
      'measurementparameters.name.u3h5': 'Harmonische 5. Ordnung',
      'measurementparameters.name.u3h50': 'Harmonische 50. Ordnung',
      'measurementparameters.name.u3h6': 'Harmonische 6. Ordnung',
      'measurementparameters.name.u3h7': 'Harmonische 7. Ordnung',
      'measurementparameters.name.u3h8': 'Harmonische 8. Ordnung',
      'measurementparameters.name.u3h9': 'Harmonische 9. Ordnung',
      'measurementparameters.name.u3hp10': 'Winkel der Harmonischen 10. Ordnung',
      'measurementparameters.name.u3hp11': 'Winkel der Harmonischen 11. Ordnung',
      'measurementparameters.name.u3hp12': 'Winkel der Harmonischen 12. Ordnung',
      'measurementparameters.name.u3hp13': 'Winkel der Harmonischen 13. Ordnung',
      'measurementparameters.name.u3hp14': 'Winkel der Harmonischen 14. Ordnung',
      'measurementparameters.name.u3hp15': 'Winkel der Harmonischen 15. Ordnung',
      'measurementparameters.name.u3hp16': 'Winkel der Harmonischen 16. Ordnung',
      'measurementparameters.name.u3hp17': 'Winkel der Harmonischen 17. Ordnung',
      'measurementparameters.name.u3hp18': 'Winkel der Harmonischen 18. Ordnung',
      'measurementparameters.name.u3hp19': 'Winkel der Harmonischen 19. Ordnung',
      'measurementparameters.name.u3hp2': 'Winkel der Harmonischen 2. Ordnung',
      'measurementparameters.name.u3hp20': 'Winkel der Harmonischen 20. Ordnung',
      'measurementparameters.name.u3hp21': 'Winkel der Harmonischen 21. Ordnung',
      'measurementparameters.name.u3hp22': 'Winkel der Harmonischen 22. Ordnung',
      'measurementparameters.name.u3hp23': 'Winkel der Harmonischen 23. Ordnung',
      'measurementparameters.name.u3hp24': 'Winkel der Harmonischen 24. Ordnung',
      'measurementparameters.name.u3hp25': 'Winkel der Harmonischen 25. Ordnung',
      'measurementparameters.name.u3hp26': 'Winkel der Harmonischen 26. Ordnung',
      'measurementparameters.name.u3hp27': 'Winkel der Harmonischen 27. Ordnung',
      'measurementparameters.name.u3hp28': 'Winkel der Harmonischen 28. Ordnung',
      'measurementparameters.name.u3hp29': 'Winkel der Harmonischen 29. Ordnung',
      'measurementparameters.name.u3hp3': 'Winkel der Harmonischen 3. Ordnung',
      'measurementparameters.name.u3hp30': 'Winkel der Harmonischen 30. Ordnung',
      'measurementparameters.name.u3hp31': 'Winkel der Harmonischen 31. Ordnung',
      'measurementparameters.name.u3hp32': 'Winkel der Harmonischen 32. Ordnung',
      'measurementparameters.name.u3hp33': 'Winkel der Harmonischen 33. Ordnung',
      'measurementparameters.name.u3hp34': 'Winkel der Harmonischen 34. Ordnung',
      'measurementparameters.name.u3hp35': 'Winkel der Harmonischen 35. Ordnung',
      'measurementparameters.name.u3hp36': 'Winkel der Harmonischen 36. Ordnung',
      'measurementparameters.name.u3hp37': 'Winkel der Harmonischen 37. Ordnung',
      'measurementparameters.name.u3hp38': 'Winkel der Harmonischen 38. Ordnung',
      'measurementparameters.name.u3hp39': 'Winkel der Harmonischen 39. Ordnung',
      'measurementparameters.name.u3hp4': 'Winkel der Harmonischen 4. Ordnung',
      'measurementparameters.name.u3hp40': 'Winkel der Harmonischen 40. Ordnung',
      'measurementparameters.name.u3hp41': 'Winkel der Harmonischen 41. Ordnung',
      'measurementparameters.name.u3hp42': 'Winkel der Harmonischen 42. Ordnung',
      'measurementparameters.name.u3hp43': 'Winkel der Harmonischen 43. Ordnung',
      'measurementparameters.name.u3hp44': 'Winkel der Harmonischen 44. Ordnung',
      'measurementparameters.name.u3hp45': 'Winkel der Harmonischen 45. Ordnung',
      'measurementparameters.name.u3hp46': 'Winkel der Harmonischen 46. Ordnung',
      'measurementparameters.name.u3hp47': 'Winkel der Harmonischen 47. Ordnung',
      'measurementparameters.name.u3hp48': 'Winkel der Harmonischen 48. Ordnung',
      'measurementparameters.name.u3hp49': 'Winkel der Harmonischen 49. Ordnung',
      'measurementparameters.name.u3hp5': 'Winkel der Harmonischen 5. Ordnung',
      'measurementparameters.name.u3hp50': 'Winkel der Harmonischen 50. Ordnung',
      'measurementparameters.name.u3hp6': 'Winkel der Harmonischen 6. Ordnung',
      'measurementparameters.name.u3hp7': 'Winkel der Harmonischen 7. Ordnung',
      'measurementparameters.name.u3hp8': 'Winkel der Harmonischen 8. Ordnung',
      'measurementparameters.name.u3hp9': 'Winkel der Harmonischen 9. Ordnung',
      'measurementparameters.name.u3ih1': 'Zwischenharmonische 1. Ordnung',
      'measurementparameters.name.u3ih10': 'Zwischenharmonische 10. Ordnung',
      'measurementparameters.name.u3ih11': 'Zwischenharmonische 11. Ordnung',
      'measurementparameters.name.u3ih12': 'Zwischenharmonische 12. Ordnung',
      'measurementparameters.name.u3ih13': 'Zwischenharmonische 13. Ordnung',
      'measurementparameters.name.u3ih14': 'Zwischenharmonische 14. Ordnung',
      'measurementparameters.name.u3ih15': 'Zwischenharmonische 15. Ordnung',
      'measurementparameters.name.u3ih16': 'Zwischenharmonische 16. Ordnung',
      'measurementparameters.name.u3ih17': 'Zwischenharmonische 17. Ordnung',
      'measurementparameters.name.u3ih18': 'Zwischenharmonische 18. Ordnung',
      'measurementparameters.name.u3ih19': 'Zwischenharmonische 19. Ordnung',
      'measurementparameters.name.u3ih2': 'Zwischenharmonische 2. Ordnung',
      'measurementparameters.name.u3ih20': 'Zwischenharmonische 20. Ordnung',
      'measurementparameters.name.u3ih21': 'Zwischenharmonische 21. Ordnung',
      'measurementparameters.name.u3ih22': 'Zwischenharmonische 22. Ordnung',
      'measurementparameters.name.u3ih23': 'Zwischenharmonische 23. Ordnung',
      'measurementparameters.name.u3ih24': 'Zwischenharmonische 24. Ordnung',
      'measurementparameters.name.u3ih25': 'Zwischenharmonische 25. Ordnung',
      'measurementparameters.name.u3ih26': 'Zwischenharmonische 26. Ordnung',
      'measurementparameters.name.u3ih27': 'Zwischenharmonische 27. Ordnung',
      'measurementparameters.name.u3ih28': 'Zwischenharmonische 28. Ordnung',
      'measurementparameters.name.u3ih29': 'Zwischenharmonische 29. Ordnung',
      'measurementparameters.name.u3ih3': 'Zwischenharmonische 3. Ordnung',
      'measurementparameters.name.u3ih30': 'Zwischenharmonische 30. Ordnung',
      'measurementparameters.name.u3ih31': 'Zwischenharmonische 31. Ordnung',
      'measurementparameters.name.u3ih32': 'Zwischenharmonische 32. Ordnung',
      'measurementparameters.name.u3ih33': 'Zwischenharmonische 33. Ordnung',
      'measurementparameters.name.u3ih34': 'Zwischenharmonische 34. Ordnung',
      'measurementparameters.name.u3ih35': 'Zwischenharmonische 35. Ordnung',
      'measurementparameters.name.u3ih36': 'Zwischenharmonische 36. Ordnung',
      'measurementparameters.name.u3ih37': 'Zwischenharmonische 37. Ordnung',
      'measurementparameters.name.u3ih38': 'Zwischenharmonische 38. Ordnung',
      'measurementparameters.name.u3ih39': 'Zwischenharmonische 39. Ordnung',
      'measurementparameters.name.u3ih4': 'Zwischenharmonische 4. Ordnung',
      'measurementparameters.name.u3ih40': 'Zwischenharmonische 40. Ordnung',
      'measurementparameters.name.u3ih41': 'Zwischenharmonische 41. Ordnung',
      'measurementparameters.name.u3ih42': 'Zwischenharmonische 42. Ordnung',
      'measurementparameters.name.u3ih43': 'Zwischenharmonische 43. Ordnung',
      'measurementparameters.name.u3ih44': 'Zwischenharmonische 44. Ordnung',
      'measurementparameters.name.u3ih45': 'Zwischenharmonische 45. Ordnung',
      'measurementparameters.name.u3ih46': 'Zwischenharmonische 46. Ordnung',
      'measurementparameters.name.u3ih47': 'Zwischenharmonische 47. Ordnung',
      'measurementparameters.name.u3ih48': 'Zwischenharmonische 48. Ordnung',
      'measurementparameters.name.u3ih49': 'Zwischenharmonische 49. Ordnung',
      'measurementparameters.name.u3ih5': 'Zwischenharmonische 5. Ordnung',
      'measurementparameters.name.u3ih6': 'Zwischenharmonische 6. Ordnung',
      'measurementparameters.name.u3ih7': 'Zwischenharmonische 7. Ordnung',
      'measurementparameters.name.u3ih8': 'Zwischenharmonische 8. Ordnung',
      'measurementparameters.name.u3ih9': 'Zwischenharmonische 9. Ordnung',
      'measurementparameters.name.u3_thd': 'THD',
      'measurementparameters.name.uextru12_max': 'Ueff max (10ms) U12',
      'measurementparameters.name.uextru12_min': 'Ueff min (10ms) U12',
      'measurementparameters.name.uextru1_max': 'Ueff max (10ms) U1E / U1N',
      'measurementparameters.name.uextru1_min': 'Ueff min (10ms) U1E / U1N',
      'measurementparameters.name.uextru23_max': 'Ueff max (10ms) U23',
      'measurementparameters.name.uextru23_min': 'Ueff min (10ms) U23',
      'measurementparameters.name.uextru2_max': 'Ueff max (10ms) U2E / U2N',
      'measurementparameters.name.uextru2_min': 'Ueff min (10ms) U2E / U2N',
      'measurementparameters.name.uextru31_max': 'Ueff max (10ms) U31',
      'measurementparameters.name.uextru31_min': 'Ueff min (10ms) U31',
      'measurementparameters.name.uextru3_max': 'Ueff max (10ms) U3E / U3N',
      'measurementparameters.name.uextru3_min': 'Ueff min (10ms) U3E / U3N',
      'measurementparameters.name.ustatu12_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu1_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu23_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu2_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu31_pst': 'Kurzzeitflicker',
      'measurementparameters.name.ustatu3_pst': 'Kurzzeitflicker',
      'measurementparameters.name.u_u2': 'Unsymmetrie u 2 (Gegen-/Mitsystem) [Prozent] mit Vorzeichen Drehsinn (ROT)',
      'measurementparameters.name.upltu12_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu1_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu23_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu2_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu31_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.upltu3_plt': 'Langzeitflicker PLT',
      'measurementparameters.name.u12m': 'Betrag von Phasor u12',
      'measurementparameters.name.u12p': 'Phase von Phasor u12',
      'measurementparameters.name.u1m': 'Betrag von Phasor u1E / u1N',
      'measurementparameters.name.u1p': 'Phase von Phasor u1E / u1N',
      'measurementparameters.name.u23m': 'Betrag von Phasor u23',
      'measurementparameters.name.u23p': 'Phase von Phasor u23',
      'measurementparameters.name.u2m': 'Betrag von Phasor u2E / u2N',
      'measurementparameters.name.u2p': 'Phase von Phasor u2E / u2N',
      'measurementparameters.name.u31m': 'Betrag von Phasor u31',
      'measurementparameters.name.u31p': 'Phase von Phasor u31',
      'measurementparameters.name.u3m': 'Betrag von Phasor u3E / u3N',
      'measurementparameters.name.u3p': 'Phase von Phasor u3E / u3N',
    },
  },
};

export default measurementParameterTranslations;
